var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"click":_vm.onUploadImg}},[_vm._t("logo"),_c('input',{ref:"uploadInput",staticClass:"el-upload__input",attrs:{"type":"file","name":"file"},on:{"change":_vm.uploadChange}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }